<div class="custom-date-field" cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggleCalendar()">
  <mat-icon class="date-field-icon-left">calendar_today</mat-icon>
  <span class="date-field-value">{{ getDateLabel() || placeholder }}</span>
  <mat-icon class="date-field-icon-close" *ngIf="startDate" (click)="clearDate(); $event.stopPropagation()">close</mat-icon>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="showCalendar"
  [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="showCalendar = false">
  <div class="custom-calendar">
    <div *ngIf="calendarView === 'year'" class="calendar-view">
      <div class="calendar-header">
        <button (click)="prevYearPage()" class="nav-btn"><mat-icon>chevron_left</mat-icon></button>
        <span class="calendar-title">{{ getYearPageRange() }}</span>
        <button (click)="nextYearPage()" class="nav-btn"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <div class="year-grid">
        <div *ngFor="let year of displayedYears" class="year-item" (click)="selectYear(year)">{{ year }}</div>
      </div>
    </div>

    <div *ngIf="calendarView === 'month'" class="calendar-view">
      <div class="calendar-header">
        <button class="nav-btn" style="visibility: hidden;"><mat-icon>chevron_left</mat-icon></button>
        <span class="calendar-title" (click)="backToYearView()" style="cursor: pointer;">{{ selectedYear }}</span>
        <button class="nav-btn" style="visibility: hidden;"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <div class="month-grid">
        <div *ngFor="let month of monthNames; let i = index" class="month-item" (click)="selectMonth(i)">{{ month }}</div>
      </div>
    </div>

    <div *ngIf="calendarView === 'date'" class="calendar-view">
      <div class="calendar-header">
        <button (click)="prevMonth()" class="nav-btn"><mat-icon>chevron_left</mat-icon></button>
        <span class="calendar-title" (click)="backToMonthView()" style="cursor: pointer;">
          {{ monthNames[selectedMonth] }} {{ selectedYear }}
        </span>
        <button (click)="nextMonth()" class="nav-btn"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <div class="calendar-weekdays">
        <div *ngFor="let day of weekDays" class="weekday">{{ day }}</div>
      </div>
      <div class="calendar-days">
        <div *ngFor="let date of calendarDays" class="calendar-day"
          [class.other-month]="!isCurrentMonth(date)"
          [class.in-range]="isDateInRange(date)"
          [class.start-date]="isStartDate(date)"
          [class.end-date]="isEndDate(date)"
          (click)="selectDate(date)">
          {{ date?.getDate() }}
        </div>
      </div>
    </div>

    <div class="calendar-actions">
      <button (click)="cancelSelection()">Cancel</button>
      <button (click)="confirmSelection()">OK</button>
    </div>
  </div>
</ng-template>
